<template>
  <v-container>
    <WrappingComponent :settings="settings" :formData="form" />
  </v-container>
</template>

<script>
import { StoreData } from "@/helpers/apiMethods";

export default {
  name: "Global",
  props: {
    settings: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    WrappingComponent: () => import("./WrappingComponent")
  },

  data() {
    return {
      form: {
        welcome: "",
        home_programs: "",
        home_products: ""
      },
      is_approved_at_adverts: null,
      locale: this.locale
    };
  },
  methods: {
    handleUpdateAdvertState() {
      const reqData = {
        is_approved_at_adverts: String(this.is_approved_at_adverts),
        locale: this.locale
      };
      this.popUp().then(value => {
        if (!value.dismiss) {
          StoreData({ reqName: "settings", data: reqData })
            .then(res => {
              console.log(res);
            })
            .catch(err => console.log(err));
        } else {
          this.is_approved_at_adverts = !this.is_approved_at_adverts;
        }
      });
    }
  },

  watch: {
    settings: {
      handler(settings) {
        if (settings) {
          this.is_approved_at_adverts = settings["is_approved_at_adverts"];
        }
      },
      immediate: true
    }
  }
};
</script>
